import { render, staticRenderFns } from "./testLayout.vue?vue&type=template&id=22e3b6c2&"
import script from "./testLayout.vue?vue&type=script&lang=js&"
export * from "./testLayout.vue?vue&type=script&lang=js&"
import style0 from "./testLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports